module.exports = __webpack_public_path__ + "img/background-content.d8395b81.png";